import { signal } from '@preact/signals-react';
export const activeModalSignal = signal({
    type: 'none',
});
export const setActiveModalSignal = (modal) => {
    activeModalSignal.value = modal;
};
